// extracted by mini-css-extract-plugin
module.exports = {"root":"TheSunHeaderLogo_root__T6Rit","logo":"TheSunHeaderLogo_logo__OWsEi","description":"TheSunHeaderLogo_description__x1j2L"};